/**
 * Raster tile URL templates for the three providers behind the `tilesService` system param.
 *
 * These are tile URLs, not the Google Maps JS SDK. Google tiles are a plain raster provider
 * (session token + key) and are unaffected by the SDK's removal. They are engine-agnostic on purpose:
 * the MapLibre raster style in `maplibre.helpers.ts` builds its sources from them.
 */

export const getGoogleTileUrl = ({
  apiKey,
  session,
}: {
  apiKey: string | undefined;
  session: string;
}): string =>
  `https://tile.googleapis.com/v1/2dtiles/{z}/{x}/{y}?session=${session}&key=${apiKey}`;

export const getMapboxTileUrl = ({
  accessToken,
  styleId = "streets-v12",
}: {
  accessToken: string;
  styleId?: string;
}): string =>
  `https://api.mapbox.com/styles/v1/mapbox/${styleId}/tiles/{z}/{x}/{y}?access_token=${accessToken}`;
